// extracted by mini-css-extract-plugin
export default {"root":"PageNavigation_root__CqPrU","stat":"PageNavigation_stat__D2yvc","label":"PageNavigation_label__CzPz+","value":"PageNavigation_value__VXoH0"};